import { render, staticRenderFns } from "./OrderCode.vue?vue&type=template&id=5d7ae537&"
import script from "./OrderCode.vue?vue&type=script&lang=js&"
export * from "./OrderCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports